<template>
    <div class="shipping-units-summary">
        <div class="shipping-units-summary-wrapper">
            <div class="shipping-units-summary__title">Totals</div>
            <div class="shipping-units-summary__value"><span>Qty:</span> <b>{{ totalItems }}</b></div>
            <div class="shipping-units-summary__value"><span>Vol:</span> <b>{{ totalVolume | dec3 }} m<sup>3</sup></b></div>
            <div class="shipping-units-summary__value"><span>Weight:</span> <b>{{ totalWeight | dec2 }} kg</b></div>
            <div class="shipping-units-summary__value" :class="{'text-danger': hasDgs}">
                <span v-if="!hasDgs">No </span><span v-else class="icon fa fa-exclamation-triangle"></span>DGs
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'QuoteItemsSummary',
    props: ['items'],
    data () {
      return {
        focusedItem: null
      }
    },
    computed: {
      totalItems () {
        return this.items.reduce((current, item) => current + parseInt(item.qty), 0)
      },
      totalVolume () {
        return this.items.reduce((current, item) => current + (item.qty * item.length * item.width * item.height), 0) / 1000000
      },
      totalWeight () {
        return this.items.reduce((current, item) => current + (item.qty * item.weight), 0)
      },
      hasDgs () {
        return this.items.reduce((current, item) => current || item.dg, false)
      }
    },

    filters: {
      dec2 (val) {
        return val.toFixed(2)
      },

      dec3 (val) {
        return val.toFixed(3)
      }
    }
  }
</script>

<style scoped>
    .shipping-units-summary {
        font-size: 0.925em;
        display: flex;
        justify-content: flex-end;
        margin-right: 40px;
    }

    .shipping-units-summary-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .shipping-units-summary-wrapper:first-child,
    .shipping-units-summary-wrapper:last-child {
        border-radius: 5px;
		border: 1px solid #e0e0e0;
    }

    .shipping-units-summary__value > * {
        margin-right: 0.25em;
    }

    .shipping-units-summary-wrapper > * {
        display: flex;
        flex-direction: row;
        justify-content: center;
        min-width: 110px;
        height: 100%;
        padding: 0.65em 1em;        
    }

    .shipping-units-summary__title {
        font-weight: bold;
        min-width: 70px;
    }

    .icon {
        line-height: 1.5em;
    }
</style>